import UserJson from "./UserJson";
import { UserPermissionType } from "./UserPermissionType";
import { UserPermissionRank } from "./UserPermissionRank";

export default interface UserPermissionJson {
   /**
    * Type der Permission. Dient auch der eindeutigen Identifikation.
    */
   type: UserPermissionType;

   /**
    * Individueller permissionRank für Permission. Überschreibt allgemeinen UserPermissionRank. Bei null gilt allgemeiner Rank.
    */
   permissionRank: UserPermissionRank | null;

   /**
    * Beschränkt die Erlaubnis auf die eigenen Daten.
    */
   limitToOwnData: boolean;
}

export function defaultUserPermissionJson(): UserPermissionJson {
   return {
      type: UserPermissionType.moduleBirthdays,
      permissionRank: null,
      limitToOwnData: false
   };
}

export function checkPermission(user: UserJson, minPermissionRank: number = 0, neededPermission: UserPermissionType | null = null, ownerID: number | null = null) {
   if(neededPermission !== null) {
      const neededUserPermission = user.userPermissions.find(i => i.type === neededPermission);


      if(neededUserPermission) {
         const userPermissionRank = neededUserPermission.permissionRank ? neededUserPermission.permissionRank : user.permissionRank;
         const userID = user.ID;

         if(userPermissionRank >= minPermissionRank || userID === ownerID) {
            if(neededUserPermission.limitToOwnData && ownerID != null) {
               if(userID === ownerID) {
                  return true;
               }
            } else {
               return true;
            }
         }
      }
   } else {
      if(user.permissionRank >= minPermissionRank) {
         return true;
      }
   }

   return false;
}